var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M90.086 0.888l-40.086 40.086-40.086-40.086-9.026 9.026 40.086 40.086-40.086 40.086 9.026 9.026 40.086-40.086 40.086 40.086 9.026-9.026-40.086-40.086 40.086-40.086z"}));
}

Close.defaultProps = {"version":"1.1","viewBox":"0 0 100 100"};

module.exports = Close;

Close.default = Close;
